import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
//-*- mode: jsx;-*-

import {SigninOverlayMessageContainer} from "./containers/SigninOverlayMessageContainer.js";
import {onSubmitEmailAndPassword, onSendInstantSignin, onSendPasswordReset, updateRedirectURLOnSigninForm, buildRedirectURL, buildPageFromType} from "./utilities/signinUtilities.js";


export const SigninOverlayPassword = createReactClass({

	propTypes: {
		onReturnToEmailView: PropTypes.func.isRequired,
		username: PropTypes.string,
		showLoadingDots: PropTypes.func.isRequired
	},

	componentDidMount: function() {
		// correct the action before submitting a password
		$(ReactDOM.findDOMNode(this)).on("keypress.passwordEntered", "#signin-password", function(e) {
			if (e.keyCode === 13) {
				$('#signin-overlay-form').attr('action', secureBaseURL + 'common/signin_json.html');
			}
		}.bind(this));
	},

	componentWillUnmount: function() {
		$(ReactDOM.findDOMNode(this)).off("keypress.passwordEntered");
	},


	onFormSubmit: function(event) {
		dcAnalytics.track("Sign in - password screen - submit");
		this.props.showLoadingDots();
		onSubmitEmailAndPassword(event);
	},

	onSendInstantSigninClick: function(event) {
		dcAnalytics.track("Sign in - password screen - magic link");
		this.props.showLoadingDots();
		onSendInstantSignin(event);
	},

	onSendForgotPasswordClick: function(event) {
		dcAnalytics.track("Sign in - password screen - forgot password");
		this.props.showLoadingDots();
		onSendPasswordReset(event);
	},

	render() {
		return (
				<div id="signin-overlay" className="overlay-padding">

					<iframe name="signin-overlay-submit-iframe2" id="signin-overlay-submit-iframe2" height="0" width="0"
							frameBorder="0" scrolling="no"></iframe>

					<div className="signin-content" id="signin-messages"><SigninOverlayMessageContainer /></div>

					<div className="signin-content" id="signin-main">
						<form className="form-redux"
							  id="signin-overlay-form"
							  method="post"
							  action={secureBaseURL + 'common/signin_json.html'}
							  onSubmit={this.onFormSubmit}
							  target="signin-overlay-submit-iframe2">
							<input type="hidden" name="action" value="window.signinOverlay2Part.signinOverlayCallback" />
							<input type="hidden" name="username" value={this.props.username} />
							<input type="hidden" name="go" value={buildRedirectURL()} />
							<input type="hidden" name="pageFromType" value={buildPageFromType()} />

							<h2>Please enter your password to continue.</h2>
							<div className="input-holder">
								<label>Email address</label>
								<div className="input-display">
									{this.props.username}
									<a href={"#"} onClick={this.props.onReturnToEmailView}>Wrong email?</a>
								</div>
							</div>
							<div className="input-holder">
								<label htmlFor="signin-password">Password</label>
								<input id="signin-password" name="password" type="password" defaultValue="" autoFocus/>
							</div>
							<div className="button-block">
								<input type="submit" className="button-primary trigger" id="signin-overlay-submit-button" value="Sign in" onClick={this.onPasswordSubmit} />
								<div>
									<a target="_parent" id="forgot-link" onClick={this.onSendForgotPasswordClick}
										href={secureBaseURL + 'donors/forgot_password.html'}>
										Forgot your password?
									</a>
								</div>
								<h4>OR</h4>
								<div>
									<a target="_parent" id="magic-link" onClick={this.onSendInstantSigninClick}
									   href={secureBaseURL + 'common/instant_signin_email.html'}>
										Send instant sign in link via email
									</a>
								</div>
							</div>
						</form>

					</div>

				</div>
		);
	}
});
